import Vue from 'vue';
import Vuex from 'vuex';
import { cloneDeep, remove } from 'lodash-es';
import itemApi from '../apis/itemApi';

Vue.use(Vuex);



export default class Store {
	state() {
		return {
			status: null,
			page: 1,
			selections: {
				topics: null,
				contentTypes: [],
				businessCategories: null
			},
			items: [],
			topics: [],
			contentTypes: [],
			businessCategories: [],
			id: null,
			layout: null,
			practiceGroups: null,
			taskForces: null,
			startDate: null,
			endDate: null,
			topicFilters: null,
			sortOrder: null,
			more: false
		};
	}

	getters() {
		return {
			status: state => {
				return state.status;
			},
			can_load_more: state => {
				return state.more;
			},
			id: state => {
				return state.id.concat("-", (Math.floor(Math.random() * 10000) + 1).toString())
			},
			layout: state => {
				return state.layout
			},
			items: state => state.items,
			selections: state => {
				return state.selections;
			},
			contentTypes: state => state.contentTypes,
			topics: state => state.topics,
			businessCategories: state => state.businessCategories,
			contentTypeChecked: state => value => {
				return state.selections.contentTypes.includes(value);
			},
			selectedContentTypes: state => {
				if(state.selections.contentTypes.length)
					return state.selections.contentTypes;
				else 
					return state.contentTypes.map(t => t.value);
			},
			selectedTopic: state => state.selections.topics,
			selectedBusinessCategory: state => state.selections.businessCategories,
			selectedSortOrder: state => state.selections.sortOrder
		};
	}

	mutations() {
		return {
			set_status(state, payload) {
				state.status = payload;
			},
			set_id(state, payload) {
				state.id = payload;
			},
			set_layout(state, payload) {
				state.layout = payload;
			},
			set_items(state, payload) {
				state.items = [
					...payload
				];
			},
			add_items(state, payload) {
				state.items = [
					...state.items,
					...payload
				];
			},
			reset_page(state) {
				state.page = 1;
			},
			increase_page(state) {
				state.page++;
			},
			set_more(state, payload) {
				state.more = payload;
			},
			select_contentType(state, filter) {
				let contentTypes = cloneDeep(state.selections.contentTypes);
				if (contentTypes.includes(filter)) remove(contentTypes, item => item === filter);
				else contentTypes.push(filter);
				state.selections.contentTypes = contentTypes;
			},
			set_contentTypes(state, contentTypes) {
				state.contentTypes = contentTypes;
			},
			set_topics(state, payload) {
				state.topics = payload;
			},
			selectTopics(state, payload) {
				state.selections.topics = payload;
			},
			set_businessCategories(state, payload) {
				state.businessCategories = payload;
			},
			selectBusinessCategories(state, payload) {
				state.selections.businessCategories = payload;
			},
			set_practiceGroups(state, payload) {
				state.practiceGroups = payload;
			},
			set_taskForces(state, payload) {
				state.taskForces = payload;
			},
			set_startDate(state, payload) {
				state.startDate = payload;
			},
			set_endDate(state, payload) {
				state.endDate = payload;
            },
			set_topicFilters(state, payload) {
				state.topicFilters = payload;
			},	
			set_sortOrder(state, payload) {
				state.sortOrder = payload;
			}
		};
	}

	actions() {
		return {
			async load_more({ commit, state, getters }, id) {
				commit('increase_page');
				commit('set_status', 'loading');
				return new Promise(resolve => {
					itemApi.load(id, state.page, state.selections.topics, getters.selectedContentTypes, state.practiceGroups, state.taskForces, state.selections.businessCategories, state.startDate, state.endDate, state.topicFilters, state.sortOrder)
						.then(res => {
							if(res && res.data)
							{
								commit('add_items', res.data.items);
								commit('set_more', res.data.more);
							}

							commit('set_status', 'loaded');
							resolve(true);
						})
						.catch(err => {
							console.error(err);
							commit('set_status', 'error');
							resolve(false);
						});
				});
			},
			async load({ commit, state, getters }) {
				commit('reset_page');
				commit('set_status', 'loading');
				return new Promise(resolve => {
					itemApi.load(state.id, state.page, state.selections.topics, getters.selectedContentTypes, state.practiceGroups, state.taskForces, state.selections.businessCategories, state.startDate, state.endDate, state.topicFilters, state.sortOrder)
						.then(res => {
							if(res && res.data)
							{
								commit('set_items', res.data.items);
								commit('set_more', res.data.more)
							}

							commit('set_status', 'loaded');
							resolve(true);
						})
						.catch(err => {
							console.error(err);
							commit('set_status', 'error');
							resolve(false);
						});
				});
			},
			async initialize({ dispatch }) {
				let status = await dispatch('load');
				return Promise.resolve(status);
			}
		};
	}
	constructor() {
		let opts = {
			state: this.state(),
			getters: this.getters(),
			mutations: this.mutations(),
			actions: this.actions()
		}
		return new Vuex.Store(opts);
	}
}
